import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'https://clownfish-app-xg4ap.ondigitalocean.app/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      window.dispatchEvent(new Event('auth-expired'));
      // Return a silent rejection so pages don't show "failed to load" on auth expiry
      return Promise.reject({ silent: true, ...error });
    }
    return Promise.reject(error);
  }
);

export default api;
